import { hasFullInvestorAccess } from "@funded-here-interface/common/src/Utils/investorAccess";
import { NAVIGATION_PATHS } from "@funded-here-interface/common/src/Utils/navigation/constants";
import { FC, ReactNode } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import { RootState } from "../../store";

interface AuthRepOnlyRouteProps {
  children: ReactNode;
}

/**
 * Keeps corporate admins/directors without the Authorised Representative role
 * out of Offer Room, Withdrawal and Risk Disclosure. The nav already hides
 * those links (InvestorLayout); this covers a typed-in URL, a bookmark and a
 * `/login/:redirectPath` deep link. Sends them to their landing page rather
 * than a permission-denied screen — Investment Portfolio is where they belong.
 */
const AuthRepOnlyRoute: FC<AuthRepOnlyRouteProps> = ({ children }) => {
  const entityType = useSelector((state: RootState) => state.auth.entityType);
  const isAuthRep = useSelector((state: RootState) => state.auth.isAuthRep);

  if (!hasFullInvestorAccess(entityType, isAuthRep)) {
    return <Navigate to={NAVIGATION_PATHS.INVESTMENT_PORTFOLIO} replace />;
  }

  return <>{children}</>;
};

export default AuthRepOnlyRoute;
